import type { BillingPeriod } from "@/components/billing-period-selector";

export type BinPlans = Partial<Record<BillingPeriod, SubscriptionPlan>>;

// Plans are keyed by duration, not name: 1 month → monthly, 12 months → yearly.
const periodForDuration = (months: number): BillingPeriod | null =>
  months === 1 ? "monthly" : months === 12 ? "yearly" : null;

export function groupPlansByBin(
  plans: SubscriptionPlan[] | undefined,
): Record<number, BinPlans> {
  const grouped: Record<number, BinPlans> = {};
  for (const plan of plans ?? []) {
    const period = periodForDuration(plan.durationMonths);
    if (!period) continue;
    const binId = Number(plan.binId);
    (grouped[binId] ??= {})[period] = plan;
  }
  return grouped;
}

// Default tab bills `defaultPrice`; Custom tab bills `price`.
export const planPrice = (plan: SubscriptionPlan, tab: "default" | "custom") =>
  Number(tab === "default" ? plan.defaultPrice : plan.price);

// Billing periods a BIN actually has a plan for, monthly first.
export const availablePeriods = (plans?: BinPlans): BillingPeriod[] =>
  (["monthly", "yearly"] as const).filter((period) => plans?.[period]);
